import * as React from 'react';
import Text, { Props as TextProps } from '../Text/Text';
import './Badge.css';

export interface Props extends TextProps {}

/**
 * A badge component, useful to provide context and highlight something
 * important to a user.
 */
const Badge: React.FunctionComponent<Props> = (props: Props) => {
  return (
    <Text { ...props }
        className="Badge"
        config="9" />
  );
};

export default Badge;
